const TRANSLATION = {
  common: {
    loading: 'Memuat',
  },
  i18n: {
    English: 'Inggris',
    Spanish: 'Spanyol',
    Russian: 'Rusia',
    'Portuguese (Brazil)': 'Portugis (Brasil)',
    Indonesian: 'Bahasa Indonesia',
    Czech: 'Ceko',
    German: 'Jerman',
    French: 'Prancis',
    Italian: 'Italia',
    Dutch: 'Belanda',
    Polish: 'Polandia',
    Vietnamese: 'Vietnam',
    Turkish: 'Turki',
    Ukrainian: 'Ukraina',
    Chinese: 'Bahasa Mandarin Sederhana',
    'Traditional Chinese': 'Bahasa Mandarin Tradisional',
    Japanese: 'Jepang',
    Korean: 'Korea',
    Arabic: 'Arab',
    Persian: 'Persia',
    Thai: 'Thai',
    Hindi: 'Hindi',
    Malay: 'Melayu',
    province: {
      Hebei: 'Provinsi Hebei',
      Shanxi: 'Provinsi Shanxi',
      Liaoning: 'Provinsi Liaoning',
      Jilin: 'Provinsi Jilin',
      Heilongjiang: 'Provinsi Heilongjiang',
      Jiangsu: 'Provinsi Jiangsu',
      Zhejiang: 'Provinsi Zhejiang',
      Anhui: 'Provinsi Anhui',
      Fujian: 'Provinsi Fujian',
      Jiangxi: 'Provinsi Jiangxi',
      Shandong: 'Provinsi Shandong',
      Henan: 'Provinsi Henan',
      Hubei: 'Provinsi Hubei',
      Hunan: 'Provinsi Hunan',
      Guangdong: 'Provinsi Guangdong',
      Hainan: 'Provinsi Hainan',
      Sichuan: 'Provinsi Sichuan',
      Guizhou: 'Provinsi Guizhou',
      Yunan: 'Provinsi Yunnan',
      Shaanxi: 'Provinsi Shaanxi',
      Gansu: 'Provinsi Gansu',
      Qinghai: 'Provinsi Qinghai',
      Taiwan: 'Provinsi Taiwan',
      Guangxi: 'Daerah Otonom Guangxi Zhuang',
      Neimenggu: 'Daerah Otonom Mongolia Dalam',
      Tibet: 'Daerah Otonom Tibet',
      Ningxia: 'Daerah Otonom Ningxia Hui',
      Xinjiang: 'Daerah Otonom Uighur Xinjiang',
      HongKong: 'Daerah Administratif Khusus Hong Kong',
      Macau: 'Daerah Administratif Khusus Makau',
      Beijing: 'Kotamadya Beijing',
      Tianjin: 'Kotamadya Tianjin',
      Shanghai: 'Kotamadya Shanghai',
      Chongqing: 'Kotamadya Chongqing',
    },
  },
  pageHeader: {
    product: 'Produk',
    tvcTest: 'Tes Pengalaman TVC',
    tvcEval: 'Evaluasi Kreatif TVC',
    contactUs: 'Hubungi Kami',
    Pricing: 'Harga',
    Dashboard: 'Mulai Sekarang',
    signIn: 'Masuk',
    signUp: 'Daftar',
    resourceCenter: 'Blog',
    all: 'Semua',
    news: 'Berita',
    insight: 'Wawasan',
    case: 'Kasus',
  },
  productSwitch: {
    common: {
      comingSoon: 'Segera hadir',
    },
    modal: {
      heroTitle: 'Silakan pilih tes yang ingin Anda jalankan',
      heroSubtitle:
        'AdEff selalu siap memberikan wawasan kreatif multidimensi kapan pun Anda membutuhkannya.',
      remainingTimes: 'Sisa penggunaan: {{count}}',
      supportedAssets: 'Aset yang didukung',
      coreMetrics: 'Metrik utama',
      cognitiveNeuroscienceIndicators: 'Indikator kognitif-neural',
      consumerAttitudeIndicators: 'Indikator sikap konsumen',
      outputResult: 'Hasil output',
      dataReport: 'Laporan data',
      analysisReport: 'Laporan analisis',
      accessBackend: 'Mulai Sekarang',
      tabs: {
        tvc: 'Tes Kreatif Horizontal',
        portrait: 'Tes Kreatif Vertikal',
      },
      cards: {
        tvcQuick: {
          title: 'Horizontal-Tes cepat',
          descriptionHighlight:
            'Nilai materi kreatif dengan cepat untuk mendorong keputusan berbasis data',
        },
        tvcBase: {
          title: 'Diagnosa Kreatif-Horizontal',
          descriptionHighlight:
            'Rinci detail kreatif dengan saran revisi yang dapat ditindaklanjuti',
          value1: 'Kreatif TVC/OTV 10–60 detik',
          value2: 'Indikator kognitif-neural',
        },
        tvcSurvey: {
          title: 'InsightPro-Horizontal',
          descriptionHighlight:
            'Analisis kreatif multi-dimensi dengan panduan optimasi strategis',
          value1: 'Kreatif TVC/OTV 10–60 detik',
          value2: 'Indikator kognitif-neural',
        },
        portraitQuick: {
          title: 'Vertikal-Tes cepat',
          descriptionHighlight:
            'Nilai materi kreatif dengan cepat untuk mendorong keputusan berbasis data',
        },
        portraitBase: {
          title: 'Diagnosa Kreatif-Vertikal',
          descriptionHighlight:
            'Rinci detail kreatif dengan saran revisi yang dapat ditindaklanjuti',
          value1: 'Kreatif vertikal 5–90 detik',
          value2: 'Indikator kognitif-neural',
        },
        portraitSurvey: {
          title: 'InsightPro-Vertikal',
          descriptionHighlight:
            'Analisis kreatif multi-dimensi dengan panduan optimasi strategis',
          value1: 'Kreatif vertikal 5–90 detik',
          value2: 'Indikator kognitif-neural',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Uji Kreatif Horizontal',
          assetText: 'Untuk kreatif TVC/OTV 10-60 detik',
        },
        portrait: {
          bannerTitle: 'Uji Kreatif Vertikal',
          assetText: 'Untuk kreatif vertikal 5-90 detik',
        },
      },
      items: {
        tvcQuick: {
          description: 'Bandingkan materi kreatif dengan cepat dan putuskan',
        },
        tvcBase: {
          title: 'Diagnosa Kreatif',
          description: 'Optimasi per detik untuk menyempurnakan materi kreatif',
        },
        tvcSurvey: {
          title: 'Insight Mendalam',
          description: 'Analisis menyeluruh untuk menemukan akar masalah',
        },
        portraitBase: {
          title: 'Diagnosa Kreatif',
          description: 'Optimasi per detik untuk menyempurnakan materi kreatif',
        },
        portraitQuick: {
          description: 'Bandingkan materi kreatif dengan cepat dan putuskan',
        },
        portraitSurvey: {
          title: 'Insight Mendalam',
          description: 'Analisis menyeluruh untuk menemukan akar masalah',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Kami menggunakan cookies',
    desc: 'Kami menggunakan cookies yang diperlukan untuk memastikan situs kami berfungsi dengan baik. Dengan persetujuan Anda, kami juga menggunakan cookies analitik untuk meningkatkan pengalaman pengguna Anda. Lihat kebijakan cookie kami di kebijakan privasi kami.',
    btn1: 'Tolak Semua',
    btn2: 'Terima Semua',
    cookiePolicy: 'Kebijakan Cookie',
  },
  landing: {
    banner: {
      text1: 'Didorong oleh AI',
      text2: 'Iklan',
      text3: 'Uji',
      text4: 'Platform pengujian dan optimasi kreatif',
      feature1: 'Dekode Konten',
      feature2: 'Prediksi Umpan Balik',
      feature3: 'Integrasi Data',
      feature4: 'Penarikan Kesimpulan',
      btn1: 'Dapatkan Demo',
      btn2: 'Buat Proyek',
    },
    info: {
      title:
        'Berdasarkan Model Bahasa Multimodal HMLLM*, cepat dalam memprediksi efektivitas kreatif, meningkatkan ROI iklan',
      subTitle:
        '*Model ini didasarkan pada banyak pengujian neuromarketing dan konstruksi multi-agensi',
      detail1: 'Pengujian Iklan Cepat',
      detail1Desc:
        'AdEff dapat memperoleh kurva perhatian audiens, fluktuasi emosi, dan keterlibatan terhadap konten kreatif dalam waktu 15 menit, serta memberikan laporan evaluasi dan panduan optimasi yang rinci.',
      detail2: 'Saring Kreatif Terbaik dengan Cepat',
      detail2Desc:
        'AdEff mendukung pengukuran beberapa kreatif secara bersamaan, membantu merek membuat keputusan cepat. Dan menyediakan analisis perbandingan yang rinci.',
      detail3: 'Sunting dengan Satu Klik, Hasilkan Versi Beragam yang Efektif',
      detail3Desc:
        'AdEff mendukung penyuntingan dengan satu klik, dapat dengan cepat menghasilkan versi yang beragam dan efektif, cocok untuk berbagai skenario penyebaran.',
    },
    advantages: {
      title: 'Keunggulan AdEff',
      item1Title: 'Respon Cepat',
      item1Desc: 'Laporan dapat diperoleh dalam waktu <tmp>15 menit</tmp>.',
      item2Title: 'Model AI yang Unik',
      item2Desc: 'Model AI <tmp>berbasis umpan balik audiens</tmp> yang unik.',
      item3Title: 'Grafik Visual',
      item3Desc:
        '<tmp>Grafik visual</tmp> + interpretasi AI cerdas, laporan pengujian dihasilkan dengan satu klik',
      item4Title: 'Ruang Data yang Besar',
      item4Desc: '<tmp>50.000+</tmp> database kreatif',
      item5Title: 'Tim Ahli',
      item5Desc: '<tmp>Tim ahli</tmp> memberikan dukungan dan panduan',
    },
    service: {
      title: 'Metode Layanan AdEff',
      desc: 'Pilih metode layanan yang Anda butuhkan',
      topTitle: 'Layanan Mandiri Online',
      topRow1: 'Membangun proyek sendiri untuk menyelesaikan pengujian',
      topRow2: 'Grafik visual + laporan interpretasi AI',
      topRow3: 'Analisis indikator neurosains objektif (mata + EEG)',
      topRow4: 'Pengujian model AI yang unik',
      bottomTitle: 'Layanan Tim Ahli',
      bottomRow1: 'Proyek dibangun oleh ahli untuk menyelesaikan pengujian',
      bottomRow2:
        'Analisis indikator neurosains objektif (mata + EEG), dapat menambah indikator subjektif',
      bottomRow3: 'Grafik visual + laporan interpretasi ahli',
      bottomRow4: 'Pengujian model AI yang unik, dapat menambah pengujian sampel nyata',
    },
    footer: {
      title:
        'AdEff didukung oleh Model Bahasa Multimodal HMLLM, membangun hubungan kompleks antara sinyal EEG elemen visual dan data pelacakan mata untuk pengujian kreatif iklan yang cepat',
      email: 'Email',
      belongDesc: 'Produk dari <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Mulai Sekarang',
  },
  contact: {
    title: 'Hubungi Kami',
    copy: 'Salin',
    message: { success: 'Salin Berhasil' },
  },
  pricing: {
    title: 'Pakar Pengujian dan Optimalisasi Kreatif yang Didukung AI',
    starter: {
      title: 'Starter',
      desc_1: 'Cocok untuk proyek sekali pakai, siap digunakan setelah pembelian',
      desc_2: 'Cocok untuk pengujian skala kecil, siap digunakan setelah pembelian',
      timesDesc: '<strong>{{count}}</strong> kali pengujian',
      timesDesc1: '<strong>{{count}}</strong> kali pengujian',
      discount: 'Diskon 50%',
      originPrice: 'Harga asli',
      desc2: 'Model AI yang kuat berdasarkan umpan balik audiens',
      desc3: 'Respon cepat hanya dalam 15 menit',
      desc4: 'Grafik visual yang kaya',
      desc5: 'Interprestasi AI yang profesional',
      desc6: 'Database global dan referensi',
      cardDesc1: 'Diskon terbatas, hanya {{pricePerTest}}',
      cardDesc2: 'Kuota tes tidak pernah kedaluwarsa',
    },
    premium: {
      time: 'kali',
    },
    unlimited: {
      title: 'Unlimited',
      cardDesc1: 'Mulai dari {{pricePerTest}}',
      cardDesc2: 'Kuota berlaku selama satu tahun',
      cardDesc3: 'Benchmark proprietary yang disesuaikan',
      planDesc500: 'Nikmati 500 tes sepanjang tahun',
      planDesc1000: 'Nikmati 1.000 tes sepanjang tahun',
    },
    benefits: {
      title: 'Mengapa memilih AdEff?',
      subtitle: 'Dengan AdEff, Anda bisa mendapatkan manfaat berikut:',
      expertSupport: 'Dukungan dan panduan dari tim ahli',
      moreNeedsTitle: 'Punya kebutuhan pembelian lainnya?',
      customPlanPrefix: 'Kami mendukung paket fleksibel dan kustom — hubungi kami di',
      customPlanSuffix: 'untuk solusi eksklusif Anda',
    },
    subscribeBtn: 'Langganan Sekarang',
    contactUs: 'Hubungi Kami',
  },
  login: {
    loginText: 'Masuk',
    signUpText: '<tmp>Daftar</tmp> gratis',
    text1: 'Berhasil bergabung dengan tim',
    text1Desc: 'Anda dapat melanjutkan pengujian iklan',
    text2: 'Pengguna telah bergabung dengan perusahaan',
    text3: 'Tautan undangan tim telah kedaluwarsa',
    text4: 'Tautan undangan tim tidak lagi berlaku.',
    optionText1: 'Sudah punya akun?',
    optionText2: 'Belum punya akun?',
    alertText1: 'Dengan mendaftar, saya setuju dengan',
    alertText2: 'Saya setuju dengan',
    termsOfService: 'Syarat Layanan',
    privacy: 'Kebijakan Privasi',
    privacyTips: 'Silakan centang kotak persetujuan sebelum mendaftar.',
    and: 'dan',
    or: 'atau',
    next: 'Selanjutnya',
    googleLogin: 'Masuk dengan Google',
    googleSignUp: 'Daftar dengan Google',
    loginWithEmail: 'Masuk dengan Email',
    signUpWithEmail: 'Daftar dengan Email',
    password: 'Kata Sandi',
    emailAddress: 'Alamat Email',
    enterEmail: 'Masukkan alamat email Anda',
    enterPassword: 'Masukkan Kata Sandi Anda',
    confirmPassword: 'Konfirmasi Kata Sandi',
    forgotPassword: 'Lupa kata sandi?',
    inconsistentPassword: 'Kata sandi tidak konsisten',
    verificationCode: 'Kode Verifikasi',
    emptyVerificationCode: 'Kode verifikasi tidak boleh kosong',
    enterVerificationCode: 'Masukkan kode verifikasi',
    sendedVerificationCode: 'Kode verifikasi telah dikirim ke email Anda',
    emailOrPasswordNotCorrect: 'Email atau kata sandi tidak benar.',
    message: {
      text1: 'Input tidak valid',
      text2: 'Email sudah terdaftar',
      text3: 'Verifikasi kode salah!',
      text4: 'Akun ini tidak terikat pada perusahaan, silakan sambungkan kembali!',
      text5: 'Silakan masukkan format email yang benar',
      text6: 'Kata sandi minimal 12 karakter',
      text7: 'Kata sandi harus mengandung huruf besar, huruf kecil, dan angka',
      requestLimit: 'Permintaan melebihi batas, silakan coba lagi nanti',
    },
  },
  resetPwdPage: {
    submit: 'Kirim',
    emailNotFound: 'Silakan periksa email Anda',
    emailHasSent: 'Email telah dikirim ke {{email}}',
    checkYourInbox: 'Periksa email Anda',
    resetYourPassword: 'Atur Ulang Kata Sandi',
    resetLinkHasSent:
      'Sebuah tautan untuk mengatur ulang kata sandi Anda telah dikirim ke alamat email yang terkait dengan akun Anda',
    enterYourEmailAddress:
      'Masukkan alamat email Anda dan kami akan mengirim Anda tautan untuk mengatur ulang kata sandi Anda',
    didNotGetEmail: 'Tidak menerima email?',
    tryAgain: 'Coba lagi',
    goBackToSign: 'Kembali ke masuk',
    email: 'Email',
    enterYourEmail: 'Masukkan alamat email Anda',
    resetPassword: 'Atur Ulang Kata Sandi',
    resetPwdSuccess: 'Kata sandi berhasil diatur ulang',
    message: {
      resetLinkCodeError: 'Kode tautan tidak valid',
      requestLimit: 'Permintaan melebihi batas, silakan coba lagi nanti',
    },
  },
  memberRequestPage: {
    title: 'Verifikasi Permintaan Anggota',
    subTitle: 'Permintaan dari:',
    deny: 'Tolak',
    approve: 'Setujui',
    teamFull: 'Tim Penuh',
    yourTeamIsFull:
      'Tim Anda sudah penuh. Anda dapat menghubungi kami untuk mendapatkan lebih banyak anggota atau menghapus anggota lain.',
    manageMembers: 'Kelola Anggota di AdEff',
    requestApproved: 'Permintaan disetujui',
    approvedDesc:
      'Anda telah menyetujui <tmp>{{name}}</tmp> untuk bergabung dengan tim Anda, pemberitahuan email telah otomatis dikirim.',
    requestDeclined: 'Permintaan ditolak',
    declinedDesc:
      'Anda telah menolak <tmp>{{name}}</tmp> untuk bergabung dengan tim Anda, pemberitahuan email telah otomatis dikirim.',
  },
  infoBindPage: {
    title: 'Pengujian Iklan Didorong oleh AI',
    desc: 'Berdasarkan Model Bahasa Multimodal HMLLM*, cepat dalam memprediksi efektivitas kreatif, meningkatkan ROI iklan',
    joinAdEff: 'Bergabunglah dengan AdEff dan mulai perjalanan baru',
    advantages: {
      title1: 'Lebih Kuat',
      desc1: 'Model AI unik berdasarkan database besar',
      title2: 'Lebih Ekonomis',
      desc2: 'Hanya 10% dari harga cara tradisional',
      title3: 'Lebih Cepat',
      desc3: 'Laporan dapat diperoleh dalam waktu 15 menit',
      title4: 'Lebih Profesional',
      desc4: 'Nikmati dukungan layanan 24/7 dan layanan tim ahli',
    },
    username: 'Nama Pengguna',
    company: 'Perusahaan',
    placeOfResidence: 'Negara/Wilayah',
    invitationCode: 'Kode Referral',
    createAccountForFree: 'Buat Akun Gratis',
    refreshStatus: 'Segarkan Status',
    reapply: 'Ajukan Ulang',
    bySigningUp: 'Mendaftar berarti setuju dengan',
    termsOfService: 'Syarat Layanan',
    and: 'dan',
    privacyPolicy: 'Kebijakan Privasi',
    message: {
      success: 'Permintaan untuk membuat akun telah dikirim, harap tunggu!',
      success2: 'Akun berhasil dibuat',
      error: 'Gagal membuat akun, silakan coba lagi nanti.',
      accountCreatedDirectly: 'Akun Anda telah dibuat secara langsung!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'Permintaan telah disetujui, halaman akan otomatis melompat.',
      theRequestHasBeenSendAndPleaseBePatient: 'Permintaan telah dikirim, harap bersabar!',
      wrongRouting: 'Kesalahan routing, halaman akan otomatis melompat.',
      yourRequestHasBeenDeclined:
        'Permintaan Anda telah ditolak. Anda dapat mengajukan ulang untuk bergabung dengan tim atau membuat akun baru tanpa kode undangan.',
      waitingForAdministratorReview: 'Menunggu tinjauan administrator',
      thisFieldIsRequired: 'Kolom ini wajib diisi',
      pleaseEnterTheResidence: 'Silakan masukkan negara',
      invitationCodeDoesNotExist: 'Kode referral tidak valid',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Jika Anda menggunakan ini melalui referral agen, silakan masukkan kode referral',
      pleaseEnterTheUsername: 'Silakan masukkan nama pengguna',
      pleaseEnterTheCompanyName: 'Silakan masukkan nama perusahaan',
      needRegisterAgain: 'Kesalahan dalam operasi, silakan daftar kembali',
      alreadyBind: 'Anda sudah mengikat perusahaan, silakan jangan mengikat kembali',
    },
  },
  knowledgeFormPage: {
    name: 'Nama Anda',
    email: 'Email Anda',
    companyName: 'Nama Perusahaan',
    department: 'Departemen',
    role: 'Jabatan',
    country: 'Negara',
    province: 'Provinsi',
    pleaseEnter: 'Silakan masukkan',
    pleaseSelect: 'Silakan pilih',
    pleaseEnterTheName: 'Silakan masukkan nama Anda',
    pleaseEnterTheEmail: 'Silakan masukkan email Anda',
    pleaseEnterValidEmail: 'Silakan masukkan email yang valid',
    pleaseEnterTheCompanyName: 'Silakan masukkan nama perusahaan Anda',
    pleaseSelectTheDepartment: 'Silakan pilih departemen Anda',
    pleaseSelectTheRole: 'Silakan pilih jabatan Anda',
    pleaseSelectTheCountry: 'Silakan pilih negara Anda',
    pleaseSelectTheProvince: 'Silakan pilih provinsi Anda',
    textIsRequired: 'Bidang ini wajib diisi',
    submit: 'Kirim',
    download: 'Unduh',
    submitSuccess: 'Kirim berhasil',
    downloadSuccess: 'Unduh berhasil',
    title1: 'Silakan isi informasi Anda untuk mendapatkan sumber daya',
    title2: 'Silakan pilih sumber daya yang ingin Anda unduh',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Unduh Laporan',
      downloadBtnText: 'Unduh PDF',
      content: 'Konten',
      theEnd: 'Akhir',
      thankYouForWatching: 'Terima kasih telah menonton.',
      pdfProcessing: 'Memproses PDF...',
      pdfProcessingDesc:
        'PDF halaman: {{count}}，diharapkan {{seconds}} detik, klik simpan setelah, silakan tunggu',
      pdfProcessingDesc2: 'Versi bahasa saat ini tidak diterjemahkan, tidak dapat membuat PDF',
    },
    ppt: {
      downloadBtnText: 'Unduh PPT',
      pptProcessingDesc: 'File PPT sedang dibuat, harap tunggu',
      pptProcessingDesc2: 'Versi bahasa saat ini belum diterjemahkan, tidak dapat membuat PPT',
      pptProcessingDesc3: 'File PPT sedang diunduh, mohon tunggu...',
      translateCompleted: 'Terjemahan PPT selesai',
      exportSuccess: 'Ekspor file PPT berhasil',
      exportFailed: 'Ekspor file PPT gagal',
    },
    layout: {
      projectMenuText: 'Proyek Pengujian Iklan',
      accountManagementText: 'Manajemen Akun',
      myAccountText: 'Akun Saya',
      subscriptionText: 'Langganan',
      logout: 'Keluar',
      dataDetails: 'Detail Data',
      dataAnalysis: 'Analisis Data',
      dataOverview: 'Ringkasan Data',
      dataComparison: 'Perbandingan Data',
    },
    systemMessage: {
      title: 'Pesan Sistem',
      task: 'Tugas',
      system: 'Sistem',
      noRelevantContent: 'Tidak ada konten yang relevan',
      noMore: 'Tidak ada pesan lagi',
    },
    projectPage: {
      createProject: 'Buat Proyek',
      searchPlaceholder: 'Masukkan nama proyek/iklan/merek untuk mencari',
      sortLabel: 'Urutkan Indeks Efektivitas Iklan',
      sortPlaceholder: 'Silakan pilih metode pengurutan',
      sortOption1: 'Urutan naik dari indeks efektivitas',
      sortOption2: 'Urutan turun dari indeks efektivitas',
      filterSort: 'Filter & Urutkan',
      filterBenchmarkTitle: 'Filter tolok ukur',
      sortTitle: 'Urutkan',
      tabAllCreative: 'Semua Kreatif ({{count}})',
      tabGeneralCreative: 'Kreatif Reguler ({{count}})',
      tabSplashCreative: 'Kreatif Splash ({{count}})',
      generalCreativeLabel: 'Kreatif Reguler',
      splashCreativeLabel: 'Kreatif Splash',
      normTypePlaceholder: 'Silakan pilih tipe nilai dasar',
      totalDesc: 'Proyek Iklan (total {{total}})',
      noRelevantContent: 'Tidak ada konten yang relevan',
      loadMore: 'Muat lagi',
      projectCard: { delete: 'Hapus', reanalyze: 'Analisis Ulang', download: 'Unduh' },
      delete: 'Hapus',
      cancel: 'Batal',
      message: {
        deleteTitle: 'Peringatan Hapus',
        delete:
          'Setelah proyek ini dihapus, semua data terkait akan menjadi tidak dapat diakses. Apakah Anda yakin ingin melanjutkan penghapusan?',
        delete1:
          'Proyek ini adalah proyek uji coba gratis, dan menghapusnya tidak akan mengembalikan kesempatan uji coba',
        delete2:
          'Proyek ini belum memulai analisis. Setelah dihapus, kredit pengujian Anda akan dikembalikan',
        deleteSuccess: 'Hapus berhasil!',
        analysisCountNotEnough: 'Jumlah analisis tidak mencukupi, silakan isi ulang dan coba lagi.',
        analysisFailed: 'Analisis gagal, silakan coba lagi nanti.',
        waitingQuestion:
          'Maksimal 3 proyek dapat dianalisis secara bersamaan. Proyek ini telah masuk antrean dan akan otomatis memulai analisis nanti.',
        landscapeQuickCompleted: 'Proyek quick test horizontal Anda selesai.',
        portraitQuickCompleted: 'Proyek quick test vertikal Anda selesai.',
        landscapeSurveyCompleted: 'Proyek insight mendalam horizontal Anda selesai.',
        portraitSurveyCompleted: 'Proyek insight mendalam vertikal Anda selesai.',
      },
    },
    projectCreatePage: {
      createProject: 'Buat Proyek',
      basicInformation: 'Informasi Dasar',
      projectType: 'Tipe Proyek',
      projectName: 'Nama Proyek',
      categoryType: 'Industri',
      brandName: 'Nama Merek',
      advertisingInformation: 'Informasi Iklan',
      adName: 'Nama Iklan',
      norm: 'Nilai Dasar',
      targetMarketNorm: 'Nilai Dasar Pasar Sasaran',
      brandNorm: 'Nilai Dasar Merek',
      taGender: 'Jenis Kelamin TA',
      targetMarket: 'Pasar Target',
      taAge: 'Usia TA',
      next: 'Selanjutnya',
      previous: 'Sebelumnya',
      confirmOrder: 'Konfirmasi Pesanan',
      estTime: 'Waktu Perkiraan',
      minutes: 'Menit',
      consumption: 'Konsumsi Pesanan Ini',
      testPoint: 'Jumlah Pengujian',
      remaining: 'Sisa',
      times: 'Kali',
      type: 'Tipe',
      purchase: 'Beli',
      outputLanguage: 'Bahasa Keluaran',
      durationCategory: 'Jenis Kreatif',
      durationCategoryDesc: 'Metrik analisis berbeda menurut jenis kreatif, silakan pilih opsi yang paling sesuai dengan konten Anda.',
      durationCategoryOptions: {
        tenPlus: 'Kreatif Umum (10d+)',
        fiveToTen: 'Kreatif Pembuka (5-10d)',
      },
      adSelection: {
        adCreativeTest: 'Uji Kreatif Iklan',
        adCreativeTestDesc:
          'Uji umpan balik audiens terhadap satu kreatif iklan, berikan analisis dan saran',
        adCreativeSelection: 'Seleksi Kreatif Iklan',
        adCreativeSelectionDesc:
          'Bandingkan umpan balik dari beberapa kreatif iklan, pilih secara komprehensif',
        adCreativeEditing: 'Penyuntingan Kreatif Iklan',
        adCreativeEditingDesc:
          'AI menyaring bagian terbaik dari kreatif iklan, secara otomatis menghasilkan kreatif iklan',
        launchingSoon: 'Segera Hadir',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Industri Makanan dan Minuman',
        packagedFood: 'Makanan Mentah',
        confectionery: 'Makanan Ringan',
        frozenMeals: 'Makanan Beku',
        fastFood: 'Makanan Cepat Saji',
        beverage: 'Minuman',
        alcohol: 'Minuman Keras',
        dairy: 'Susu',
        grainAndSeasoning: 'Bahan Penyedap',
        beverageMixes: 'Minuman Campuran',
        freshProduce: 'Buah Segar',
        otherFoodAndBeverage: 'Makanan dan Minuman Lainnya',
        /**----------------------- */
        consumerElectronicsCategory: 'Industri Elektronik Konsumen',
        mobilePhone: 'Telepon Seluler',
        computer: 'Komputer',
        smartDevice: 'Perangkat Cerdas',
        phoneAccessories: 'Aksesori Telepon',
        computerAccessories: 'Aksesori Komputer',
        software: 'Perangkat Lunak',
        camera: 'Kamera',
        officeSupplies: 'Perlengkapan Kantor',
        otherConsumerElectronics: 'Elektronik Konsumen Lainnya',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Industri Farmasi dan Kesehatan',
        otcMedicine: 'Obat Bebas',
        prescriptionDrugs: 'Obat Berobat',
        healthSupplements: 'Suplemen Kesehatan',
        pharmaceuticalCompanies: 'Perusahaan Farmasi',
        medicalDevices: 'Alat Kesehatan',
        medicalServices: 'Layanan Kesehatan',
        pharmacy: 'Apotek',
        otherPharmaceuticalsAndHealthCare: 'Farmasi dan Kesehatan Lainnya',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Industri Kecantikan dan Perawatan Pribadi',
        hairCare: 'Perawatan Rambut',
        womenSkincare: 'Perawatan Kulit Wanita',
        homeCleaning: 'Perawatan Rumah',
        bodyCare: 'Perawatan Tubuh',
        feminineCare: 'Perawatan Wanita',
        oralCare: 'Perawatan Mulut',
        menSkincare: 'Perawatan Kulit Pria',
        makeup: 'Perawatan Wajah',
        fragrances: 'Perawatan Wajah',
        beautyServices: 'Perawatan Wajah',
        otherBeautyAndPersonalCare: 'Kecantikan dan Perawatan Pribadi Lainnya',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Industri Bayi dan Anak',
        babyFood: 'Makanan Bayi',
        babyCareEssentials: 'Kebutuhan Bayi',
        babyToys: 'Mainan Bayi',
        otherMaternalAndInfantProducts: 'Bayi dan Anak Lainnya',
        /**----------------------- */
        networkAndCommunicationCategory: 'Industri Jaringan dan Komunikasi',
        mobileCarriers: 'Operator Seluler',
        internetProviders: 'Penyedia Internet',
        telecomEquipment: 'Perangkat Telekomunikasi',
        otherNetworkAndCommunication: 'Jaringan dan Komunikasi Lainnya',
        /**----------------------- */
        travelAndAccommodationCategory: 'Industri Perjalanan dan Akomodasi',
        localTourism: 'Perjalanan Lokal',
        bookingPlatform: 'Platform Pemesanan',
        hotels: 'Hotel',
        airlines: 'Penerbangan',
        airport: 'Bandara',
        otherTravelAndAccommodation: 'Perjalanan dan Akomodasi Lainnya',
        /**----------------------- */
        vehiclesCategory: 'Industri Kendaraan',
        motorVehicleProductsAndServices: 'Produk dan Layanan Kendaraan',
        carBrands: 'Merek Mobil',
        dealerships: 'Dealer',
        carFinance: 'Kredit Mobil',
        evCar: 'Mobil Listrik',
        motorcycle: 'Motor',
        onlineUsedCarMarketplace: 'Platform Jual Beli Mobil Bekas',
        carRentalPlatform: 'Platform Sewa Mobil',
        travelNavigation: 'Navigasi Perjalanan',
        bicycle: 'Sepeda',
        otherVehicles: 'Kendaraan Lainnya',
        /**----------------------- */
        householdAppliancesCategory: 'Industri Peralatan Rumah Tangga',
        majorAppliances: 'Peralatan Rumah Tangga Besar',
        healthAndPersonalCareAppliances: 'Peralatan Kesehatan dan Perawatan Pribadi',
        majorKitchenAndBathAppliances: 'Peralatan Dapur dan Kamar Mandi Besar',
        smallKitchenAppliances: 'Peralatan Dapur dan Kamar Mandi Kecil',
        environmentalAppliances: 'Peralatan Lingkungan',
        cleaningAppliances: 'Peralatan Pencucian',
        otherHouseholdAppliances: 'Peralatan Rumah Tangga Lainnya',
        /**----------------------- */
        retailAndServiceCategory: 'Industri Retail dan Layanan',
        onlineRetailEcommerce: 'Retail Online/E-commerce',
        departmentStores: 'Departemen',
        lifeServices: 'Layanan Kehidupan',
        retailServicesAndDelivery: 'Layanan Retail/Pengiriman',
        supermarkets: 'Supermarket',
        otherRetailAndService: 'Retail dan Layanan Lainnya',
        /**----------------------- */
        apparelCategory: 'Industri Pakaian',
        footwear: 'Sepatu',
        clothing: 'Pakaian',
        watchesWatchRetail: 'Jam/Toko Jam',
        jewelry: 'Perhiasan',
        bags: 'Tas',
        eyewearOpticalStores: 'Kacamata/Toko Kacamata',
        otherClothingAndAccessories: 'Pakaian dan Aksesori Lainnya',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Industri Perbaikan dan Perlengkapan Rumah',
        homeFurnishing: 'Perlengkapan Rumah',
        homeImprovement: 'Perbaikan Rumah',
        otherHomeImprovementAndFurnishings: 'Perbaikan dan Perlengkapan Rumah Lainnya',
        /**----------------------- */
        financialAndInsuranceCategory: 'Industri Keuangan dan Asuransi',
        bank: 'Bank',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Jasa Keuangan',
        insurance: 'Asuransi',
        otherFinancialAndInsurance: 'Keuangan dan Asuransi Lainnya',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Industri Hiburan dan Olahraga',
        socialApp: 'Aplikasi Sosial',
        toysAndDolls: 'Mainan dan Boneka',
        concerts: 'Konser',
        events: 'Acara',
        movies: 'Film',
        themeParks: 'Taman Tema',
        gambling: 'Perjudian',
        onlineGaming: 'Permainan Online',
        tvChannels: 'Saluran TV',
        otherEntertainmentAndLeisure: 'Hiburan dan Olahraga Lainnya',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Industri Pertanian dan Pertambangan',
        industrialSupplies: 'Bahan Industri',
        agriculturalSupplies: 'Bahan Pertanian',
        otherIndustrialAndAgricultural: 'Industri dan Pertanian Lainnya',
        /**----------------------- */
        petLifeCategory: 'Industri Hewan Peliharaan',
        petFood: 'Makanan Hewan Peliharaan',
        petSupplies: 'Peralatan Hewan Peliharaan',
        otherPetLife: 'Hewan Peliharaan Lainnya',
        /**----------------------- */
        educationAndLearningCategory: 'Industri Pendidikan dan Pelatihan',
        onlineLearning: 'Pendidikan Online',
        schools: 'Sekolah',
        skillCourses: 'Kursus Keahlian',
        tutoring: 'Pengajar',
        universities: 'Universitas',
        otherEducationAndLearning: 'Pendidikan dan Pelatihan Lainnya',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Industri Komunitas dan Layanan Publik',
        charityCampaigns: 'Kampanye Donasi',
        ngoAds: 'Iklan NGO',
        otherCommunityAndPublicService: 'Komunitas dan Layanan Publik Lainnya',
        /**----------------------- */
        otherCategory: 'Lainnya',
        governmentAdvertising: 'Iklan Pemerintah',
        realEstateAdvertising: 'Iklan Properti',
        otherAdvertising: 'Iklan Lainnya',
      },
      genderSelect: {
        male: 'Pria',
        female: 'Wanita',
        all: 'Semua',
      },
      targetMarketSelect: {
        China: 'Tiongkok',
        HongKongChina: 'Hong Kong, Tiongkok',
        MacauChina: 'Makau, Tiongkok',
        TaiwanChina: 'Taiwan, Tiongkok',
        Japan: 'Jepang',
        Korea: 'Korea',
        Mongolia: 'Mongolia',
        Singapore: 'Singapura',
        Thailand: 'Thailand',
        Vietnam: 'Vietnam',
        Malaysia: 'Malaysia',
        Philippines: 'Filipina',
        Indonesia: 'Indonesia',
        Cambodia: 'Kamboja',
        Laos: 'Laos',
        India: 'India',
        SaudiArabia: 'Arab Saudi',
        Turkey: 'Turki',
        Israel: 'Israel',
        UnitedArabEmirates: 'Uni Emirat Arab',
        Qatar: 'Qatar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'Inggris',
        France: 'Prancis',
        Germany: 'Jerman',
        Netherlands: 'Belanda',
        Belgium: 'Belgia',
        Austria: 'Austria',
        Italy: 'Italia',
        Spain: 'Spanyol',
        Portugal: 'Portugal',
        Greece: 'Yunani',
        Sweden: 'Swedia',
        Norway: 'Norwegia',
        Finland: 'Finlandia',
        Denmark: 'Denmark',
        Estonia: 'Estonia',
        Latvia: 'Latvia',
        Russia: 'Rusia',
        Poland: 'Polandia',
        CzechRepublic: 'Republik Ceko',
        Hungary: 'Hungaria',
        Romania: 'Rumania',
        Bulgaria: 'Bulgaria',
        Slovakia: 'Slovakia',
        Slovenia: 'Slovenia',
        Ukraine: 'Ukraina',
        UnitedStates: 'Amerika Serikat',
        Canada: 'Kanada',
        Mexico: 'Meksiko',
        Brazil: 'Brasil',
        LatinAmerica: 'Amerika Latin',
        Australia: 'Australia',
        NewZealand: 'Selandia Baru',
        Other: 'Lainnya',
      },
      languageSelect: {
        english: 'Inggris',
        chinese: 'Tiongkok',
        japanese: 'Jepang',
        korean: 'Korea',
        french: 'Prancis',
        traditionalChinese: 'Bahasa Mandarin Tradisional',
      },
      placeholder: {
        projectName: 'Masukkan Nama Proyek',
        category: 'Pilih Kategori',
        brandName: 'Masukkan Nama Merek',
        adName: 'Masukkan Nama Iklan',
        norm: 'Silakan pilih nilai acuan',
        taGender: 'Pilih Jenis Kelamin',
        targetMarket: 'Pilih Pasar Target',
        taAge: 'Pilih Usia',
        lowerLimit: 'Batas Bawah',
        upperLimit: 'Batas Atas',
        outputLanguage: 'Silakan pilih bahasa keluaran',
      },
      step: {
        step1: 'Input Informasi Proyek',
        step2: 'Konfirmasi Informasi Pesanan',
      },
      message: {
        success: 'Berhasil dibuat',
        videoDurationOver60s: 'Durasi video lebih dari {{max}} detik',
        videoDurationLessThan10s: 'Durasi video kurang dari {{min}} detik',
        videoDurationNeedOver10s: 'Durasi video harus lebih dari 10 detik',
        videoDurationNeedWithin5To10s: 'Durasi video harus antara 5 hingga 10 detik',
        videoDurationNotMatchDurationCategory: 'Durasi video saat ini tidak memenuhi tipe proyek ini. Silakan unggah ulang video lalu coba lagi.',
        videoUploadingCannotSwitchDurationCategory: 'Anda tidak dapat mengganti jenis kreatif saat video sedang diunggah. Harap tunggu hingga unggahan selesai.',
        videoFormatOrDurationError: 'Tidak dapat membaca format atau durasi video. Periksa file video lalu coba lagi.',
        videoSizeOver200M: 'Ukuran video lebih dari 256MB',
        videoLandscape: 'Video harus dalam format horizontal',
        videoPortrait: 'Video harus dalam format vertikal',
        clickToUploadTestVideo: 'Klik untuk mengunggah video uji',
        uploadFailed: 'Unggahan gagal, silakan coba lagi',
        uploadDesc1: 'Mendukung file video horizontal dalam format MP4, MOV',
        uploadDescPortrait: 'Mendukung file video vertikal dalam MP4, MOV',
        uploadDesc2: 'dengan batas ukuran file 256 MB',
        formNotCompleted: 'Silakan lengkapi informasi',
        uploadAdVideo: 'Silakan unggah video iklan',
        inputInvalid: 'Input tidak valid',
        insufficientTestPoints: 'Poin uji tidak mencukupi, silakan isi ulang dan coba lagi.',
        reviewProjectInfo:
          'Silakan periksa informasi proyek Anda dengan cermat. Setelah pesanan dikonfirmasi, tidak dapat diubah.',
        waitingDesc:
          'Maksimal 3 proyek dapat dianalisis secara bersamaan. Proyek ini telah masuk antrean dan akan otomatis memulai analisis nanti.',
        ageRangeInvalid: 'Rentang usia hanya mendukung 20-55',
        normDesc: 'Keuntungan hak cipta tak terbatas, nilai referensi perusahaan',
      },
    },
    projectDetailPage: {
      testResults: 'Hasil Uji',
      share: 'Bagikan',
      shareFailed: 'Gagal membagikan',
      shareModal: {
        title: 'Bagikan',
        desc: 'Salin teks di bawah ini dan bagikan di media sosial.',
        saveImage: 'Simpan Gambar',
        copyText: 'Salin Teks',
        copySuccess: 'Berhasil disalin',
        copyFailed: 'Gagal menyalin',
        textTemplate:
          'Wow! Kreatif AI saya mengungguli {{score}}% karya sejenis di AdEff! Data adalah bukti yang sesungguhnya! AdEff AI Creative Testing sekarang gratis. Cek skor Anda di {{hostname}}. Dapatkan 5 tes gratis, semoga Anda meraih ulasan terbaik!',
      },
      sharePoster: {
        createdByYou: 'Dibuat oleh Anda',
        scoreTemplate: 'Mengungguli <score>{{score}}</score> kreatif AIGC',
        statsAt: 'Statistik pada ',
        certification: 'Sertifikasi Kreativitas',
        footerText: 'Teruslah berkarya dan hadirkan lebih banyak karya berkualitas!',
      },
      basicInformation: 'Informasi Dasar',
      waiting: 'Menunggu',
      ongoing: 'Sedang Berlangsung',
      failed: 'Gagal',
      tryAgain: 'Coba Lagi',
      videoAnalysisFailed: 'Analisis video gagal',
      message: { projectNotFound: 'Proyek tidak ditemukan' },
      primaryAnalysis: 'Kinerja Utama',
      detailAnalysis: 'Analisis Detail',
      heatmapAnalysis: 'Peta Panas',
      analysisStepDesc:
        'AI telah menyelesaikan semua tugas analisis, analisis rinci sebagai berikut',
      analysisWaitingDesc:
        'Maksimal 3 proyek dapat dianalisis secara bersamaan. Proyek ini telah masuk antrean dan akan otomatis memulai analisis nanti',
      aiTip: 'Konten laporan dihasilkan oleh AI dan hanya untuk referensi',
      subAnalysisDescription: {
        adVideoScore: 'Indeks Efektivitas Iklan',
        adVideoScoreDesc:
          'Indeks efektivitas iklan adalah indikator integral efektivitas iklan, dapat memprediksi efek jangka pendek dan panjang iklan.',
        norm: 'Nilai Dasar',
        normDesc:
          'Nilai dasar dari data industri atau sejarah, digunakan untuk perbandingan kinerja iklan.',
        attentionIndex: 'Indeks Perhatian',
        attentionIndexDesc:
          'Tingkat konsentrasi perhatian visual audiens, mencerminkan kemampuan elemen dan plot iklan untuk menarik perhatian.',
        emotionIndex: 'Indeks Emosi',
        emotionIndexDesc:
          'Tingkat emosi positif yang dipicu oleh audiens, mencerminkan fluktuasi emosi yang dihasilkan oleh iklan.',
        cognitionIndex: 'Indeks Kognisi',
        cognitionIndexDesc:
          'Mencerminkan tingkat pemrosesan kognitif audiens, yaitu sejauh mana mereka memikirkan konten iklan.',
        theGolden3Seconds: 'Tiga Detik Emas',
        theGolden3SecondsDesc:
          'Tiga detik pertama iklan adalah momen kunci yang menentukan keberhasilan iklan.',
        informationTransmission: 'Momen Informasi',
        informationTransmissionDesc:
          'Mengukur kemampuan momen informasi iklan untuk menangkap perhatian audiens target dan memicu minat.',
        brandRelevance: 'Momen Merek',
        brandRelevanceDesc:
          'Mengukur kemampuan momen merek untuk menangkap perhatian audiens target dan memicu minat.',
        interestStimulation: 'Momen Ketertarikan',
        interestStimulationDesc:
          'Momen kunci yang memicu resonansi emosional dan kognisi aktif audiens.',
        theEnding3Seconds: 'Tiga Detik Akhir',
        theEnding3SecondsDesc:
          'Berdasarkan hukum puncak-akhir, tiga detik terakhir iklan adalah momen kunci untuk memperkuat perhatian penonton dan meningkatkan penyampaian informasi.',
      },
      infoDrawer: {
        basicInformation: 'Informasi Dasar',
        advertisingInformation: 'Informasi Iklan',
        projectName: 'Nama Proyek',
        brandName: 'Nama Merek',
        category: 'Industri',
        norm: 'Nilai Dasar Pasar Sasaran',
        normLabel: 'Nilai Dasar',
        brandNorm: 'Nilai Dasar Merek',
        adName: 'Nama Iklan',
        taGender: 'Jenis Kelamin TA',
        targetMarket: 'Pasar Target',
        taAge: 'Usia TA',
        ageRange: '{{start}} hingga {{end}} tahun',
        modify: 'Ubah',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
      },
      videoView: {
        eyeMovementRatio: 'Indeks Perhatian',
        cognitiveEngagement: 'Indeks Kognisi',
        emotionRecognition: 'Indeks Emosi',
        subjectiveResponseCurve: 'Kurva Respon Subjektif',
        realtimeData: 'Data Nyata',
        panoramicData: 'Data Panorama',
        indexAnalysis: 'Analisis Indeks',
        advantage: 'Keunggulan',
        disadvantage: 'Kekurangan',
        suggestions: 'Saran',
        adVideoScore: 'Indeks Efektivitas Iklan',
        norm: 'Nilai Dasar',
        analysisStepTitle1: 'Dekode Konten',
        analysisStepTitle2: 'Prediksi Umpan Balik',
        analysisStepTitle3: 'Integrasi Data',
        analysisStepTitle4: 'Penarikan Kesimpulan',
        analysisStepDesc1:
          'Mulai mendekode konten iklan secara multimodal, mendekode visual, audio, teks, dan struktur...',
        analysisStepDesc2:
          'Mulai memprediksi respon subjektif audiens, berdasarkan konten iklan per detik, memprediksi data mata dan EEG audiens...',
        analysisStepDesc3:
          'Mulai mengintegrasikan konten objektif iklan dan data respon subjektif audiens...',
        analysisStepDesc4:
          'Mulai menghasilkan kesimpulan evaluasi dan saran tindakan berdasarkan model penarikan kesimpulan...',
        keyResult: 'Hasil Utama',
        videoChart: {
          videoFailed: 'Video playback gagal',
          videoFailedAction:
            'Silakan refresh dan coba lagi. Jika masalah terus berlanjut setelah beberapa refresh, silakan hubungi kami untuk bantuan.',
        },
      },
      storyboardView: {
        summary: 'Ringkasan',
        advantages: 'Keunggulan',
        disadvantages: 'Kekurangan',
        suggestions: 'Saran',
        keyResult: 'Hasil Utama',
        norm: 'Nilai Dasar',
        theGolden3Seconds: 'Tiga Detik Emas',
        informationTransmission: 'Momen Informasi',
        brandRelevance: 'Momen Merek',
        interestStimulation: 'Momen Ketertarikan',
        theEnding3Seconds: 'Tiga Detik Akhir',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'Email',
      username: 'Nama Pengguna',
      password: 'Kata Sandi',
      setPasswordToEnableEmailLogin: 'Atur kata sandi untuk mengaktifkan login email',
      uid: 'UID',
      contactAndReceiveNotifications: 'Hubungi dan terima notifikasi',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Terima email tentang pembaruan terbaru AdEff dengan email ini.',
      myWorkspace: 'Ruang Kerja Saya',
      newRequest: 'Permintaan Baru',
      invitationCode: 'Kode Referral',
      userName: 'Nama pengguna',
      invitationCodeDesc:
        'Setiap tim memiliki kode undangan unik untuk pengguna baru saat mendaftar untuk bergabung dengan tim',
      table: {
        userName: 'Nama Pengguna',
        email: 'Email',
        operation: 'Operasi',
        admin: 'Admin',
        remove: 'Hapus',
        deny: 'Tolak',
        approve: 'Setujui',
      },
      message: {
        yourTeamIsFull:
          'Tim Anda sudah penuh. Anda dapat menghubungi kami untuk mendapatkan lebih banyak anggota atau menghapus anggota lain.',
        invitationLinkSent: 'Tautan undangan telah dikirim ke alamat email ini!',
        removeReminder: 'Peringatan Hapus',
        remove: 'Hapus',
        removeMember:
          'Setelah menghapus anggota, konten yang dibuat oleh anggota tersebut akan tetap ada. Apakah Anda ingin melanjutkan penghapusan anggota?',
        removeMemberSuccess: 'Anggota berhasil dihapus!',
        ok: 'Oke',
        contactUs: 'Hubungi Kami',
        applicationProcessedSuccessfully: 'Permohonan berhasil diproses!',
        notificationSettingsTurnedOn: 'Pengaturan notifikasi telah diaktifkan',
        notificationSettingsTurnedOff: 'Pengaturan notifikasi telah dinonaktifkan',
        setPassword: 'Atur Kata Sandi',
        passwordConfirm: 'Konfirmasi',
        passwordCancel: 'Batal',
        oldPassword: 'Kata Sandi Lama',
        newPassword: 'Kata Sandi Baru',
        pleaseEnterTheOldPassword: 'Silakan masukkan kata sandi lama',
        pleaseEnterTheNewPassword: 'Silakan masukkan kata sandi baru',
        incorrectEntryOfOriginalPassword: 'Masukan kata sandi asli salah',
        passwordUpdatedSuccessfully: 'Kata sandi berhasil diperbarui',
        changeUsername: 'Ubah Nama Pengguna',
        confirm: 'Konfirmasi',
        cancel: 'Batal',
        username: 'Nama Pengguna',
        pleaseEnterTheNewUsername: 'Silakan masukkan nama pengguna baru',
        userNameUpdatedSuccessfully: 'Nama pengguna berhasil diperbarui',
        addMemberToWorkspace: 'Tambahkan Anggota Baru ke Ruang Kerja',
        notAdminOperate: 'Bukan admin, tidak dapat melakukan operasi',
        emailAddress: 'Alamat Email',
        send: 'Kirim',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Kami akan mengirimkan email undangan ke alamat ini untuk konfirmasi.',
        workspaceMemberShip: 'Keanggotaan Ruang Kerja',
        forMoreMembership: 'Lebih Banyak Keanggotaan',
        reachedTheCeiling: 'Jumlah anggota telah mencapai batas.',
        incorrectMailboxFormat: 'Format email tidak benar',
        member: 'Anggota',
        changeCorpNameTitle: 'Ubah Nama Perusahaan',
        changeCorpNameLabel: 'Nama Perusahaan',
        pleaseEnterTheCorpName: 'Silakan masukkan nama perusahaan',
        changeCorpNameSuccess: 'Nama perusahaan berhasil diubah',
        changeCorpNameFailed: 'Ubah nama perusahaan gagal',
        noPermission: 'Anda tidak memiliki izin untuk mengubah nama perusahaan',
      },
    },
    subscriptionPage: {
      currentPlan: 'Rencana Saat Ini',
      getInvoice: 'Dapatkan Faktur Anda',
      remainingTimes: 'Sisa Kali',
      purchaseMore: 'Beli Lebih Banyak',
      contactUs: 'Hubungi Kami',
      teamPlan: 'Layanan Tim Ahli',
      unlimited: 'Tak Terbatas',
      dueDate: 'Tanggal Berakhir',
      table: {
        usageRecords: 'Rekaman Penggunaan',
        date: 'Tanggal',
        projectName: 'Nama Proyek',
        projectType: 'Tipe Proyek',
        usageCount: 'kali',
        userName: 'Nama Pengguna',
        noRelevantContent: 'Tidak ada konten yang relevan',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Proyek Kreatif Reguler',
      regularCreative: 'Kreatif Reguler',
      splashCreativeProject: 'Proyek Kreatif Splash',
      splashCreative: 'Kreatif Splash',
      projects: 'Proyek',
      localNorm: 'Benchmark Lokal',
      projectPassRate: 'Tingkat Lulus Proyek',
      passRate: 'Tingkat Lulus',
    },
    dataDetailPage: {
      baseData: 'Data Dasar',
      totalProjects: 'Total Proyek',
      totalProjectsDesc:
        'Jumlah semua proyek yang efektif yang terlibat dalam evaluasi efektivitas iklan.',
      // averageEffectivenessIndex: 'Indeks Efektivitas Rata-rata',
      // averageEffectivenessIndexDesc:
      // 'Rata-rata indeks efektivitas iklan dari semua proyek yang efektif.',
      localNormProjects: 'Proyek Dasar Lokal',
      brandNormProjects: 'Proyek Dasar Merek',
      normProject: 'Proyek Nilai Dasar Pasar Sasaran',
      brandNormProject: 'Proyek Dasar Merek',
      localNorm: 'Nilai Dasar Lokal',
      localNormDesc:
        'Rata-rata indeks efektivitas iklan dari proyek iklan yang valid dengan negara Anda sebagai target pasarnya.',
      norm: 'Nilai Dasar',
      brandNorm: 'Nilai Dasar Merek',
      brandNormDesc:
        'Rata-rata indeks efektivitas iklan dari proyek iklan yang valid dengan nilai dasar merek Anda sebagai target pasarnya.',
      localProjectPassRate: 'Rata-rata Proyek Lokal',
      projectPassRate: 'Rata-rata Proyek',
      brandProjectPassRate: 'Rata-rata Proyek Merek',
      projectPassRateDesc:
        'Rata-rata proyek yang efektif yang terlibat dalam evaluasi efektivitas iklan.',
      advertisingEffectivenessIndexDistribution: 'Distribusi Indeks Efektivitas Iklan',
      advertisingEffectivenessIndexDistributionDesc:
        'Distribusi indeks efektivitas iklan dari semua proyek yang efektif.',
      item: 'item',
    },
    dataComparisonPage: {
      createCompare: 'Perbandingan Baru',
      createCompareDesc: 'Pilih beberapa proyek untuk dibandingkan, hingga 10 proyek.',
      startCompare: 'Mulai Perbandingan',
      compareReport: 'Laporan Perbandingan',
      searchPlaceholder: 'Cari nama laporan perbandingan',
      emptyText: 'Belum ada laporan perbandingan. Pilih proyek untuk dibandingkan terlebih dahulu.',
      searchEmptyText: 'Laporan perbandingan tidak ditemukan.',
      deleteTitle: 'Hapus Laporan Perbandingan',
      deleteConfirm: 'Yakin ingin menghapus laporan perbandingan ini? Tindakan ini tidak dapat dibatalkan.',
      projectCount: '{{count}} proyek',
    },
    dataComparisonStartPage: {
      back: 'Kembali',
      basicInfo: 'Informasi Dasar',
      reportName: 'Nama Laporan:',
      reportNamePlaceholder: 'Masukkan nama laporan perbandingan',
      norm: 'Tolok Ukur:',
      normPlaceholder: 'Pilih tolok ukur',
      normTip: 'Pilih tolok ukur yang digunakan untuk perbandingan proyek',
      selectProject: 'Pilih Proyek',
      searchPlaceholder: 'Cari berdasarkan nama proyek/iklan/merek',
      selectedCountPrefix: ' Dipilih ',
      selectedCountSuffix: ' proyek, hingga {{max}} proyek',
      startCompare: 'Mulai Perbandingan',
      save: 'Simpan',
      cancel: 'Batal',
      maxSelectedWarning: 'Anda dapat memilih hingga 10 proyek',
      reportNameRequired: 'Masukkan nama laporan perbandingan',
      normRequired: 'Pilih tolok ukur',
      projectRequired: 'Pilih proyek',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Nama Laporan Perbandingan',
      reportNotFound: 'Laporan tidak ditemukan',
      back: 'Kembali',
      modify: 'Edit',
      deletedProjectTip: 'Proyek berikut: {{names}} telah dihapus. Setelah dikonfirmasi, laporan perbandingan akan diperbarui dan proyek yang dihapus akan dikeluarkan.',
      confirmDeletedProjects: 'Konfirmasi',
      metricScore: 'Skor Indikator',
      tabDimension: 'Lima Dimensi',
      tabMoment: 'Momen Kunci',
      tabAttitude: 'Sikap Konsumen',
      adeffScore: 'Skor AdEff',
      brandName: 'Nama Merek',
      projectName: 'Nama Proyek',
      industry: 'Industri',
      targetMarket: 'Pasar Target',
      gender: 'Gender TA',
      age: 'Usia TA',
      adProject: 'Proyek Iklan',
      normLabel: 'Tolok Ukur',
      mixedCreativeBenchmarkTip: 'Tidak ada benchmark saat membandingkan creative umum dan splash secara bersamaan.',
      emptyProject: 'Pilih proyek untuk melihat data perbandingan',
      viewProjectDetail: 'Lihat Detail Proyek',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Daya Perhatian',
        infectivity: 'Daya Emosional',
        delivery: 'Daya Pesan',
        brand: 'Daya Merek',
        persuasion: 'Daya Persuasif',
        gazeRecognition: 'Pengenalan Tatapan',
        emotionRecognition: 'Pengenalan Emosi',
        engagementRecognition: 'Pengenalan Keterlibatan',
        goldenSeconds: 'Tiga Detik Emas',
        brandMoment: 'Momen Merek',
        productMoment: 'Momen Ketertarikan',
        messageMoment: 'Momen Informasi',
        endingSeconds: 'Tiga Detik Akhir',
        likeability: 'Kesukaan',
        newInformation: 'Informasi Baru',
        messageRelevance: 'Relevansi Pesan',
        comprehension: 'Pemahaman',
        credibility: 'Kredibilitas',
        brandLinkage: 'Keterkaitan Merek',
        uniqueness: 'Keunikan',
        learnMoreIntent: 'Keinginan untuk Tahu Lebih Banyak',
        purchaseIntent: 'Niat Membeli',
        recommendIntent: 'Kemudahan Dibagikan',
        brandLikeabilityLift: 'Peningkatan Kesukaan Merek',
        purchaseIntentionLift: 'Peningkatan Niat Beli',
        attentionIndex: 'Indeks Perhatian',
        emotionIndex: 'Indeks Emosi',
        cognitionIndex: 'Indeks Kognisi',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Proyek evaluasi kreatif TVC Anda telah selesai.',
        title: {
          text1: 'Pengujian Kreatif Iklan',
          text2: 'Laporan Pengujian',
        },
        flowAnalysis: {
          desc1: 'AdEff sedang mengurai iklan video Anda',
          desc2: 'Penguraian video selesai',
          desc3: 'Menganalisis perhatian visual konsumen',
          desc4: 'Menganalisis fokus visual berdasarkan profil konsumen',
          desc5: 'Membuat heatmap perhatian',
          desc6: 'Heatmap dinamis telah dibuat',
          desc7: 'Mengukur respons kognitif-neural',
          desc8: 'Melacak tatapan, emosi, dan keterlibatan detik demi detik',
          desc9: 'Membuat kurva respons neural',
          desc10: 'Kurva respons neural telah dibuat',
          desc11: 'Menganalisis performa pada momen kunci',
          desc12: 'Mengukur respons kognitif-neural selama: 3 detik emas, momen pesan, momen merek, puncak minat, dan 3 detik terakhir',
          desc13: 'Mensintesis metrik momen kunci',
          desc14: 'Analisis momen kunci selesai',
          desc15: 'Menganalisis sikap konsumen',
          desc16: 'Menganalisis sikap terhadap merek, produk, dan konten',
          desc17: 'Mensintesis metrik sikap',
          desc18: 'Metrik sikap selesai',
          desc19: 'Membuat skor lima daya pendorong',
          desc20: 'Skor lima daya pendorong siap',
          desc21: 'Analisis selesai! Laporan performa iklan Anda siap',
          terminology: {
            thumbExpand: 'Perluas thumbnail',
            thumbCollapse: 'Ciutkan thumbnail',
            gazeRecognition: 'Pengenalan Tatapan',
            gazeRecognitionDesc: 'Mengukur konsentrasi perhatian visual dan menunjukkan seberapa efektif elemen iklan menangkap fokus penonton.',
            emotionRecognition: 'Pengenalan Emosi',
            emotionRecognitionDesc: 'Mengukur emosi positif dan respons afektif langsung yang dipicu oleh iklan.',
            engagementRecognition: 'Pengenalan Keterlibatan',
            engagementRecognitionDesc: 'Mengukur imersi dan keterlibatan, mencerminkan investasi mental pada konten iklan.',
            theGolden3Seconds: 'Performa 3 Detik Emas',
            theGolden3SecondsDesc: 'Mengevaluasi efektivitas konten iklan selama 3 detik awal.',
            keyMessage: 'Performa Pesan Kunci',
            keyMessageDesc: 'Mengukur kemampuan momen informasi iklan untuk menangkap perhatian dan merangsang minat.',
            brand: 'Performa Merek',
            brandDesc: 'Menilai penangkapan perhatian khusus merek dan efektivitas keterlibatan.',
            interest: 'Puncak Minat',
            interestDesc: 'Mengidentifikasi puncak konten yang memicu resonansi emosional dan keterlibatan tinggi.',
            ending3Seconds: 'Performa 3 Detik Terakhir',
            ending3SecondsDesc: 'Mengevaluasi efektivitas konten iklan pada 3 detik terakhir.',
            score: 'Skor',
            benchmark: 'Tolok ukur',
            metrics: 'Metrik',
            attitudePart: {
              attitudeMetrics: 'Metrik Sikap',
              liking: 'Kesukaan',
              likingDesc: 'Mengukur sikap subjektif audiens dan tingkat kesukaan keseluruhan terhadap iklan.',
              newInformation: 'Informasi Baru',
              newInformationDesc: 'Mengukur apakah audiens merasa memperoleh informasi berharga yang sebelumnya belum diketahui tentang merek atau produk dari iklan.',
              messageRelevance: 'Relevansi Pesan',
              messageRelevanceDesc: 'Mengukur sejauh mana audiens memandang informasi dalam iklan berkaitan langsung dengan diri mereka.',
              comprehension: 'Pemahaman',
              comprehensionDesc: 'Mengukur apakah pesan utama iklan dipahami dengan jelas, akurat, dan mudah oleh audiens.',
              credibility: 'Kredibilitas',
              credibilityDesc: 'Mengukur sejauh mana audiens percaya bahwa informasi yang disampaikan benar, andal, dan dapat dipercaya.',
              brandLinkage: 'Keterkaitan Merek',
              brandLinkageDesc: 'Mengukur kemampuan audiens untuk mengaitkan iklan secara benar dan kuat dengan merek tertentu.',
              uniqueness: 'Keunikan',
              uniquenessDesc: 'Mengukur apakah iklan berhasil membangun persepsi jelas bahwa merek memiliki keunikan yang berbeda dan bernilai dibanding pesaing.',
              willing: 'Keinginan untuk Tahu Lebih Banyak',
              willingDesc: 'Mengukur kemungkinan subjektif audiens untuk mengambil langkah aktif mempelajari merek atau produk lebih lanjut setelah melihat iklan.',
              purchase: 'Niat Membeli',
              purchaseDesc: 'Mengukur kemungkinan subjektif audiens untuk mempertimbangkan memilih atau membeli produk merek di masa depan.',
              share: 'Kemudahan Dibagikan',
              shareDesc: 'Mengukur kemungkinan subjektif audiens untuk secara aktif membagikan iklan atau informasi merek kepada orang lain.',
              brandLikeLift: 'Peningkatan Kesukaan Merek',
              brandLikeLiftDesc: 'Mengukur arah dan tingkat perubahan kesukaan keseluruhan terhadap merek atau produk setelah terpapar iklan.',
              purchaseIntentLift: 'Peningkatan Niat Beli',
              purchaseIntentLiftDesc: 'Mengukur arah dan tingkat perubahan kemauan untuk mempertimbangkan membeli produk merek setelah terpapar iklan.',
            },
            dimensionPart: {
              forceDrives: 'Daya Pendorong',
              attension: 'Perhatian',
              emotionalImpact: 'Dampak Emosional',
              messageClarity: 'Kejelasan Pesan',
              brandPower: 'Kekuatan Merek',
              persuasion: 'Persuasi',
              attentionForce: 'Daya Perhatian',
              attentionForceDesc: 'Mengukur kemampuan iklan untuk menangkap dan mempertahankan perhatian visual dan auditori audiens.',
              emotionalForce: 'Daya Emosional',
              emotionalForceDesc: 'Mengukur intensitas resonansi emosional langsung dan instingtif serta fluktuasi yang dipicu oleh konten iklan.',
              messageForce: 'Daya Pesan',
              messageForceDesc: 'Mengukur efektivitas pesan inti iklan dalam dikenali jelas, dipahami akurat, dan diingat kuat oleh audiens target.',
              brandForce: 'Daya Merek',
              brandForceDesc: 'Mengukur efektivitas iklan dalam memperkuat identitas merek, meningkatkan favorabilitas, dan membangun koneksi merek yang kuat.',
              persuasiveForce: 'Daya Persuasif',
              persuasiveForceDesc: 'Mengukur kekuatan akhir iklan untuk mengubah persepsi dan mendorong niat perilaku.',
            },
            result: {
              results: 'Hasil',
              pass: 'Lulus',
              notPass: 'Tidak Lulus',
              adeffScore: 'Skor AdEff',
              adeffScoreDesc: 'Skor AdEff dirancang untuk mengukur efektivitas keseluruhan iklan.',
              benchmarkDesc: 'Rata-rata skor AdEff semua iklan yang diunggah di negara atau wilayah iklan digunakan sebagai pembanding performa iklan.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Menunggu...',
            description: 'Sedang membuat laporan pengujian untuk Anda...',
          },
          generating: 'Sedang dibuat...',
          freeTrialLockText1:
            'Dalam mode uji coba, pratinjau dan unduhan laporan lengkap tidak tersedia.',
          freeTrialLockText2: 'Berlangganan untuk membuka akses.',
        },
      },
    },
  },
  professor: {
    account: 'Akun',
    password: 'Kata Sandi',
    login: 'Masuk',
    expertReviews: 'Ulasan Ahli',
    adVideoScore: 'Indeks Efektivitas Iklan',
    subjectiveResponseCurve: 'Kurva Respon Subjektif',
    indexAnalysis: 'Analisis Indeks',
    keyResult: 'Hasil Utama',
    theGolden3Seconds: 'Tiga Detik Emas',
    informationTransmission: 'Momen Informasi',
    brandRelevance: 'Momen Merek',
    interestStimulation: 'Momen Ketertarikan',
    theEnding3Seconds: 'Tiga Detik Akhir',
    heatMap: 'Peta Panas',
    suggestion: 'Saran',
    suggestion1: 'Saran',
    submit: 'Kirim',
    next: 'Selanjutnya',
    summary: 'Ringkasan',
    advantages: 'Keunggulan',
    disadvantages: 'Kekurangan',
    option1: 'Diprediksi',
    option2: 'Tidak Diprediksi',
    resultJudgment: 'Ulasan',
    placeholder: 'Masukkan saran',
    waitRateCount: 'Jumlah Iklan untuk Dinilai',
    unfinishedTitle: 'Peringatan',
    unfinishedRate: 'Ulasan memiliki item yang belum dinilai',
    unfinishedConfirm: 'Lanjutkan ulasan',
    unfinishedCancel: 'Keluar',
    message: {
      submitSuccess: 'Terima kasih atas ulasan Anda',
      submitSuccess1: 'Anda telah menyelesaikan ulasan proyek ini, terima kasih atas ulasan Anda',
      loginSuccess: 'Masuk berhasil',
      rateUnfinished:
        'Anda belum menilai konten saat ini, silakan isi sebelum melanjutkan ke pertanyaan berikutnya',
      rateLocation: 'Kami telah secara otomatis menempatkan item yang belum dinilai untuk Anda',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Minta uji coba',
      title1: 'Uji coba gratis',
      trial: 'Uji coba',
      hiddenBoxText1: 'Ditemukan beberapa keunggulan, kekurangan, dan saran',
      hiddenBoxText2: 'Berlangganan untuk mendapatkan laporan lengkap',
      hiddenBoxBtn: 'Berlangganan sekarang',
      applyBox: {
        name: 'Nama Anda',
        tel: 'Nomor Kontak',
        department: 'Departemen',
        role: 'Peran',
        country: 'Negara',
        city: 'Kota',
        pleaseEnter: 'Silakan masukkan',
        pleaseSelect: 'Silakan pilih',
        pleaseEnterTheName: 'Silakan masukkan nama Anda',
        pleaseEnterTheTel: 'Silakan masukkan nomor kontak Anda',
        pleaseEnterValidTel: 'Silakan masukkan nomor kontak yang valid',
        pleaseEnterValidEmail: 'Silakan masukkan email yang valid',
        pleaseSelectTheDepartment: 'Silakan pilih departemen Anda',
        pleaseSelectTheRole: 'Silakan pilih peran Anda',
        pleaseSelectTheCountry: 'Silakan pilih negara Anda',
        pleaseEnterTheCity: 'Silakan masukkan kota Anda',
        textIsRequired: 'Bidang ini wajib diisi',
        submit: 'Kirim',
        tip: 'Setiap perusahaan hanya memiliki satu kesempatan uji coba gratis',
      },
      gotTrial: 'Anda telah mendapatkan uji coba!',
      goPc: 'Silakan pergi ke versi web PC untuk membuat proyek Anda.',
      back: 'Kembali',
      country: {
        China: 'Tiongkok',
        Japan: 'Jepang',
        Korea: 'Korea',
        Indonesia: 'Indonesia',
        Thailand: 'Thailand',
        Singapore: 'Singapura',
        Malaysia: 'Malaysia',
        Vietnam: 'Vietnam',
        Germany: 'Jerman',
        Britain: 'Inggris',
        France: 'Prancis',
        Italy: 'Italia',
        Russia: 'Rusia',
        Spain: 'Spanyol',
        Turkey: 'Turki',
        America: 'Amerika Serikat',
        Canada: 'Kanada',
        Brazil: 'Brasil',
        Other: 'Lainnya',
      },
      department: {
        Brand: 'Merek',
        Market: 'Pasar',
        Marketing: 'Pemasaran',
        IT: 'IT',
        Procurement: 'Pengadaan',
        Other: 'Lainnya',
      },
      role: {
        President: 'Presiden/Wakil Presiden/Manajer Umum',
        CMO: 'CMO atau Manajemen tingkat C lainnya',
        Director: 'Direktur Departemen',
        Manager: 'Manajer Departemen',
        Other: 'Lainnya',
      },
      message: {
        submitSuccess: 'Kirim berhasil',
        submitFailed: 'Kirim gagal, silakan coba lagi',
      },
    },
    downloadPptRechargeModal: {
      title: 'Laporan tidak dapat diunduh',
      desc1: 'Dalam versi uji coba, Anda tidak dapat mengunduh laporan',
      desc2: 'Berlangganan untuk mendapatkan laporan lengkap',
      btn: 'Berlangganan sekarang',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Kode Referral',
      invitationCodeDesc1:
        'Kode referral tidak dapat diubah, silakan hubungi kami jika Anda ingin mengubahnya',
      invitationCodeDesc2:
        'Jika Anda menggunakan ini melalui referral agen, silakan masukkan kode referral',
      invitationCodePlaceholder: 'Silakan masukkan kode referral',
      invitationCodeError: 'Kode referral tidak valid',
      invitationCodeSuccess: 'Kode referral berhasil diubah',
      ok: 'Oke',
      cancel: 'Batal',
    },
    aigcPromotionModal: {
      title: 'Benefit Kreator AIGC',
      subTitle: 'Daftar sekarang untuk mendapatkan <tmp>5</tmp> kesempatan evaluasi video AI',
      desc1: 'Bergabunglah dengan Event AdEff AI Creative Testing untuk mengevaluasi kreatif Anda.',
      desc2: 'Daftar sekarang dan langsung klaim 5 tes gratis.',
      registerBtn: 'Daftar untuk mendapatkan kesempatan uji',
      tip: 'Hanya untuk pengguna baru yang mendaftar melalui pintu masuk kampanye Kreator AIGC',
      floatTitle: 'Uji coba gratis',
    },
  },
}

export default TRANSLATION
